export { default } from "./Table";
export { default as Table } from "./Table";
export { default as Head } from "./Head";
export { default as Rows } from "./Rows";
export { iTableColumn, iTableRow } from "./interfaces";
